import { flagError, type ErrorSink } from 'error-handling'

/** A form's id and the language it serves. */
export interface FundraisingFormRef {
  formId: string
  formLang: string
}

/** A fundraising island's failure, tagged with the page's form once it has one. */
export function reportFundraisingError(
  error: unknown,
  context: string,
  form: FundraisingFormRef,
  sink?: ErrorSink,
): void {
  flagError(error as Error, `fundraising/${context}`, sink, form.formId ? { ...form } : '')
}
